import { ReactNode } from "react";
import React from "react";

type Props = {
  children?: ReactNode;
  classNames?: string;
};

/**
 * ヘッダーなしレイアウト
 * @constructor
 */
const NoHeaderLayout = ({ children, classNames = "bg-theme-thin" }: Props) => {
  return (
    <div className={`min-h-screen ${classNames}`}>
      <div className="flex flex-col items-center">
        <main className="grow mt-14 md:mb-0 w-full max-w-[760px]">
          {children}
        </main>
      </div>
    </div>
  );
};

export default NoHeaderLayout;
